import Icon from 'veui/components/Icon'
import { IconArrowDown } from 'dls-icons-vue'

Icon.register('arrow-down', IconArrowDown)
